// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-ForgotPassword__forgotPassword__root","instructions":"cmp-ForgotPassword__forgotPassword__instructions"};